import { isNotEmptyArray } from '@rumblefish/ui/Rumblefish23Theme';
import type { FC } from 'react';
import { JobPostSection, JobPostList } from '..';
import type { RequirementsProps } from './Requirements.types';

export const Requirements: FC<RequirementsProps> = ({
  basicTechStack,
  greatIfYouKnow,
  importantTraits,
}) => {
  if (
    !isNotEmptyArray(basicTechStack) &&
    !isNotEmptyArray(greatIfYouKnow) &&
    !isNotEmptyArray(importantTraits)
  ) {
    return null;
  }
  return (
    <JobPostSection banner="Requirements" title="Who are we looking for?">
      <JobPostList title="Basic tech stack" items={basicTechStack} />
      <JobPostList title="Great, if you know" items={greatIfYouKnow} />
      <JobPostList title="Important traits" items={importantTraits} />
    </JobPostSection>
  );
};
